export default __webpack_public_path__ + "static/media/8.d42e9391.jpg";